import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Ticker from "./components/Ticker";
import Countdown from "./components/Countdown";
import About from "./components/About";
import Priorities from "./components/Priorities";
import Visions from "./components/Visions";
import Program from "./components/Program";
import Meetings from "./components/Meetings";
import Transparent from "./components/Transparent";
import Pledge from "./components/Pledge";
import News from "./components/News";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import Seo from "./seo/Seo";
import { homeGraph, faqGraph } from "./seo/jsonld";
import { faqItems } from "./components/Faq";
import ProgramPage from "./pages/ProgramPage";
import ProgramAreaPage from "./pages/ProgramAreaPage";
import AboutPage from "./pages/AboutPage";
import NewsPage from "./pages/NewsPage";
import NewsArticlePage from "./pages/NewsArticlePage";
import NotFound from "./pages/NotFound";
import useVisitTracker from "./hooks/useVisitTracker";
import { Toaster } from "./components/ui/toaster";

const HOME_TITLE = "Ján Kuráň – kandidát na primátora Ružomberka 2026";
const HOME_DESC =
  "Oficiálny web Jána Kuráňa, kandidáta na primátora Ružomberka v komunálnych voľbách 2026. Pozrite si jeho priority, víziu a volebný program pre Ružomberok. Volebné číslo 3.";

const Home = () => {
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="App">
      <Seo
        title={HOME_TITLE}
        description={HOME_DESC}
        path="/"
        jsonLd={[
          homeGraph({ path: "/", title: HOME_TITLE, description: HOME_DESC }),
          faqGraph(faqItems),
        ]}
      />
      <Header />
      <Hero />
      <Ticker />
      <Countdown />
      <About />
      <Priorities />
      <Visions />
      <Program />
      <Ticker bg="bg-campaign-ink" text="text-campaign-yellow" />
      <Transparent />
      <Pledge />
      <Meetings />
      <News />
      <Faq />
      <Footer />
    </div>
  );
};

function App() {
  useVisitTracker();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/o-mne" element={<AboutPage />} />
        <Route path="/program" element={<ProgramPage />} />
        <Route path="/program/:slug" element={<ProgramAreaPage />} />
        <Route path="/aktuality" element={<NewsPage />} />
        <Route path="/aktuality/:slug" element={<NewsArticlePage />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
